import { render, staticRenderFns } from "./PopularScienceDetails.vue?vue&type=template&id=589a9cba&scoped=true&"
import script from "./PopularScienceDetails.vue?vue&type=script&lang=js&"
export * from "./PopularScienceDetails.vue?vue&type=script&lang=js&"
import style0 from "./PopularScienceDetails.vue?vue&type=style&index=0&id=589a9cba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589a9cba",
  null
  
)

export default component.exports